module.exports = __webpack_public_path__ + "img/Karriere_Hintergrund.d46485ff.jpg";